<template>
	<div
		class="spinner-wrapper"
		:class="{ center }"
	>
		<img
			v-show="timeoutFinished"
			class="spinner-image"
			:src="`/images/loading-spinner-${theme}${isAtv ? '-atv' : ''}.webp`"
			:aria-label="transUcfirst('commons.loading') || hint"
		>
	</div>
</template>

<script>
import { transUcfirst } from '../../util/transHelpers';

export default {
	name:  'LoadingSpinner',
	props: {
		theme: {
			type:      String,
			default:   'dark',
			validator: (value) => ['light', 'dark'].includes(value),
		},
		hint: {
			type:    String,
			default: '',
		},
		center: {
			type: Boolean,
		},
		delay: {
			type:    Number,
			default: 1000,
		},
	},
	data() {
		return {
			timeoutFinished: false,
			timeout:         null,
			isAtv:           window.isAtv,
		};
	},
	mounted() {
		this.startTimeout();
	},
	destroyed() {
		clearTimeout(this.timeout);
	},
	methods: {
		transUcfirst,
		startTimeout() {
			// Give it time one second to load
			this.timeout = setTimeout(() => {
				this.timeoutFinished = true;
			}, this.delay);
		},
	},
};
</script>

<style lang="scss" scoped>
.spinner-wrapper {
	width: 100%;
	height: 100%;

	&.center {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.spinner-image {
		width: 64px;
		height: 64px;
	}
}
</style>
